import _ from 'underscore';
import template from '../template/keyword-bidlandscape.pug';
import { ProductGroupBidLandscapeViewModel } from './viewmodel';
import { BidLandscapeBaseView } from '../base-view';

export class ProductGroupBidLandscape extends BidLandscapeBaseView {
  get ViewModel() {
    return ProductGroupBidLandscapeViewModel;
  }

  get template() {
    return () => template(_.extend(this.viewModel, {
      isForVNext: this.isForVNext,
    }));
  }
}
